<template>
  <div class="acceptance-form">
    <tg-title>Não foi possível aceitar os termos. </tg-title>
    <tg-text
      >Algo deu errado e não conseguimos salvar sua resposta. Por favor, tente
      novamente. Se o problema persistir, entre em contato com nosso
      suporte.</tg-text
    >
    <div class="acceptance-actions">
      <tg-button type="button" :loading="loading" @click="accept"
        >Tentar novamente</tg-button
      >
    </div>
  </div>
</template>
<script>
import NewAcceptanceStatusMixin from "@/mixins/NewAcceptanceStatusMixin";
import TangramTitle from "@/components/Tangram/Title.vue";
import TangramText from "@/components/Tangram/Text.vue";
import TangramButton from "@/components/Tangram/Button.vue";

export default {
  name: "NewAcceptTermRetry",

  mixins: [NewAcceptanceStatusMixin],

  components: {
    "tg-title": TangramTitle,
    "tg-text": TangramText,
    "tg-button": TangramButton,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {};
  },

  methods: {
    accept() {
      this.$emit("accepted", this.acceptanceSteps.RETRY);
    },
  },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@400;600&display=swap");

:root {
  font-family: "Red Hat Display", sans-serif;
}

.company-name {
  color: #11a7b6;
}

.acceptance-form {
  width: 100%;
  height: auto;
  gap: 24px 0;
  padding-left: 72px;
  display: flex;
  flex-direction: column;
}
</style>
